import { useEffect, useState } from "react";
import { useSync } from "@/lib/live";
import { Link } from "react-router-dom";
import { Bell, BellOff } from "lucide-react";
import { api, fmtDateTime } from "@/lib/api";
import { useApp } from "@/context/AppContext";
import { PageTitle } from "@/components/Layout";

export default function Notifications() {
  const { t, refreshSummary } = useApp();
  const [rows, setRows] = useState(null);
  const load = () => api.get("/notifications").then((r) => {
      setRows(r.data);
      if (r.data.some((n) => !n.read)) api.post("/notifications/read-all").then(refreshSummary);
    }).catch(() => setRows((x) => x || []));
  useEffect(() => { load(); }, []); // eslint-disable-line
  useSync(load);
  if (!rows) return <p className="text-[#7B968B]">{t("Loading…")}</p>;
  return (
    <div className="space-y-3">
      <PageTitle>{t("Notifications")}</PageTitle>
      {!rows.length && <div className="py-10 text-center text-[#4A6358]" data-testid="notifications-empty"><BellOff className="mx-auto mb-2 h-10 w-10 text-[#7B968B]" />{t("No notifications yet.")}</div>}
      {rows.map((n) => (
        <Link key={n.id} to={n.link || "#"} data-testid={`notification-${n.id}`}
          className={`flex gap-3 rounded-2xl border p-4 ${n.read ? "border-[#D2E0D8] bg-white" : "border-[#2E9E6B] bg-[#2E9E6B]/5"}`}>
          <Bell className={`mt-0.5 h-5 w-5 shrink-0 ${n.read ? "text-[#7B968B]" : "text-[#2E9E6B]"}`} />
          <div className="flex-1">
            <p className="font-semibold text-[#0D3B2B]">{t(n.title)}</p>
            <p className="text-sm text-[#4A6358]">{n.body}</p>
            <p className="mt-1 text-xs text-[#7B968B]">{fmtDateTime(n.created_at)}</p>
          </div>
          {!n.read && <span className="mt-1 h-2.5 w-2.5 rounded-full bg-[#E05C3A]" />}
        </Link>
      ))}
    </div>
  );
}
